export default __webpack_public_path__ + "static/media/roboto-latin-900italic.cb5ad999.woff2";